'use client';

import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { SiteHeader } from './site-header.js';
import { SiteSidebar } from './site-sidebar.js';
import { useNavigation } from '../../hooks/use-navigation.js';
import { Outlet } from 'react-router-dom';  // import Outlet
import illustrator from "../../assets//illustrator/illus-background-2.png"
import { useEffect, useState } from 'react';

export function AppLayout() {
  const { dynamicNav } = useNavigation();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Detect dark mode by checking html class
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, { attributes: true });
    setIsDark(document.documentElement.classList.contains("dark"));
    return () => observer.disconnect();
  }, []);

  return (
    <SidebarProvider>
      <SiteSidebar menuItems={dynamicNav} />
      <SidebarInset>
        <SiteHeader menuItems={dynamicNav} />
        <main
          className="flex-1 p-2 md:p-3 lg:p-3 bg-cover bg-no-repeat"
          style={{
            backgroundImage: !isDark ? `url(${illustrator})` : "none",
            backgroundPosition: "top right",
          }}
        >
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}